import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

interface ImportHandlerProps {
  onImport: (chartId: string) => Promise<void>;
}

/**
 * Component that handles import detection from URL parameters.
 * Must be rendered inside a Router context to use useSearchParams.
 * 
 * Requirements: 1.3, 1.4, 1.5, 7.1, 7.2, 7.3, 7.5
 */
export const ImportHandler: React.FC<ImportHandlerProps> = ({ onImport }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const importChartId = searchParams.get('import');

    if (importChartId) {
      onImport(importChartId);
      // Clear the import parameter from URL
      searchParams.delete('import');
      setSearchParams(searchParams, { replace: true });
    }
  }, []); // Run once on mount

  return null; // This component doesn't render anything
};
